'use strict';

export const REQUEST_HANLO = "REQUEST_HANLO";
export const RECIEVE_HANLO = "RECIEVE_HANLO";
export const RECIEVE_ERROR_HANLO = "RECIEVE_ERROR_HANLO";



// WEBPACK FOOTER //
// ./src/actions/action.type.js